import React from "react";

export default function ParagraphBlock({
  className,
  children,
  text,
  ...other
}) {
  return (
    <p {...other} className={`report-block__paragraph ${className}`}>
      {text}
      {children}
    </p>
  );
}
